import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EntityService {
  constructor(private http: HttpClient) {}

  getEntityProfileDetails(
    spear_id: string,
  ): Observable<any> {
    return this.http.get<any>(
      `${environment.fireStoreApiUrl}/api/v1/profile/${spear_id}/`
    );
  }

  updateEntityAliasData(profile_id:number,req:any): Observable<any> {
    return this.http.put<any>(
      `${environment.fireStoreApiUrl}/api/v2/profiles/alias/${profile_id}/`,
      req
    );
  }

}
